"use strict";

exports.__esModule = true;
exports.default = exports.clearBrowserCheckCookie = exports.setBrowserCheckHasBeenCompletedCookie = exports.browserCheckCompleted = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _uaParserJs = _interopRequireDefault(require("ua-parser-js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BROWSER_CHECK_COOKIE_NAME = 'browserCheck';
var CHROME_BROWSER = 'Chrome';
var MIN_CHROME_VERSION = 43;
var SAFARI_BROWSER = 'Safari';
var MOBILE_SAFARI_BROWSER = 'Mobile Safari';
var MIN_SAFARI_VERSION = 12;
var browserCheckCompleted = _jsCookie.default.get(BROWSER_CHECK_COOKIE_NAME) !== undefined;
exports.browserCheckCompleted = browserCheckCompleted;

var setBrowserCheckHasBeenCompletedCookie = function setBrowserCheckHasBeenCompletedCookie() {
  return _jsCookie.default.set(BROWSER_CHECK_COOKIE_NAME, new Date());
};

exports.setBrowserCheckHasBeenCompletedCookie = setBrowserCheckHasBeenCompletedCookie;

var clearBrowserCheckCookie = function clearBrowserCheckCookie() {
  return _jsCookie.default.remove(BROWSER_CHECK_COOKIE_NAME);
};

exports.clearBrowserCheckCookie = clearBrowserCheckCookie;

var enforceBrowserCheck = function enforceBrowserCheck() {
  var parser = new _uaParserJs.default();
  var browserResult = parser.getBrowser();
  var parsedBrowserVersion = parseFloat(browserResult.version);

  if (!browserCheckCompleted) {
    if (!(browserResult.name === CHROME_BROWSER && parsedBrowserVersion >= MIN_CHROME_VERSION || browserResult.name === SAFARI_BROWSER && parsedBrowserVersion >= MIN_SAFARI_VERSION || browserResult.name === MOBILE_SAFARI_BROWSER && parsedBrowserVersion >= MIN_SAFARI_VERSION)) {
      return true;
    }
  }

  return false;
};

var _default = enforceBrowserCheck;
exports.default = _default;